import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/entities/Arbeitsbereich';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';

interface Station {
  id: string;
  von: Date;
  bis: Date;
  abschnittId: string;
}

export class ArbeitsbereichStation implements Station {
  constructor({
    von,
    bis,
    arbeitsbereich,
    bereichsleiter,
    abschnittId,
    lernziele,
    id,
  }: {
    id: string;
    von: Date;
    bis: Date;
    arbeitsbereich: Arbeitsbereich;
    bereichsleiter?: Mitarbeiter;
    abschnittId: string;
    lernziele: string;
  }) {
    this.id = id;
    this.von = von;
    this.bis = bis;
    this.arbeitsbereich = arbeitsbereich;
    this.bereichsleiter = bereichsleiter;
    this.abschnittId = abschnittId;
    this.lernziele = lernziele;
  }

  id: string;
  abschnittId: string;
  von: Date;
  bis: Date;
  arbeitsbereich: Arbeitsbereich;
  bereichsleiter?: Mitarbeiter;
  lernziele: string;
}

export class AbwesenheitsStation implements Station {
  constructor({
    von,
    bis,
    titel,
    abschnittId,
    id,
  }: {
    von: Date;
    bis: Date;
    titel: string;
    abschnittId: string;
    id: string;
  }) {
    this.von = von;
    this.bis = bis;
    this.titel = titel;
    this.abschnittId = abschnittId;
    this.id = id;
  }

  id: string;
  von: Date;
  bis: Date;
  titel: string;
  abschnittId: string;
}
